/* =====================================================================
 * 클립보드 쓰기 — 비보안 컨텍스트 폴백 포함.
 *
 * 온프렘 배포는 사내망 IP 위의 평문 HTTP 로 접속하는 경우가 있고, 그런
 * 컨텍스트에서는 `navigator.clipboard` 자체가 존재하지 않는다. 그래서
 * `navigator.clipboard.writeText(...)` 를 곧바로 부르면 복사가 실패하는
 * 정도가 아니라 TypeError 로 터진다. 호출부마다 이걸 기억할 수는 없으므로
 * 한 군데로 모은다.
 * ===================================================================== */

/**
 * `text` 를 클립보드에 쓴다. 성공 여부를 돌려주고 예외는 던지지 않는다.
 *
 * 1차로 Clipboard API 를, 없거나 거부되면 `execCommand('copy')` 를 쓴다.
 * 후자는 평문 HTTP 에서도 동작하지만 사용자 제스처 안에서 호출해야 하므로,
 * 클릭 핸들러 밖(타이머·응답 콜백 등)에서 부르면 실패할 수 있다.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* 권한 거부·비활성 문서 등 — 레거시 경로로 넘어간다. */
    }
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
